export default "__VITE_ASSET__ed08d1c1__"